import { getItemByKeyRecursive } from '@/components/Lists/lib';
import { clickableTypesByView, activeInspectorTypes as types } from '@/constants/inspectorViewTypes';
import api from '@/api';
import isEmpty from 'lodash/isEmpty';
import { filterItems } from '@/components/WellLoggingOperations/Inspector/GeoObjects/FilterDropDown/createDropDownItems';

function mapping(clickableType) {
    return clickableTypesByView[clickableType] || types.DEFAULT;
}

const parseId = compositeId => {
    return compositeId.split('-').map(Number);
};

const inspectorModel = {
    state: {
        visible: false,
        wellTitle: '',
        objects: [],
        /*
            Это поле для хранения созданных пользователем версий ригис и ФГИ 530.
            Хранится по ключу. Ключом выступает id скважины, либо ключ группы.
        */
        customGeoObjects: {},

        /*
            Это поле для хранения версий ригис и ФГИ 530.
            Хранится по ключу. Ключом выступает id скважины, либо ключ группы.
        */
        allWellVersions: {},
        allCustomGeoVersions: [],
        allMinesAndWells: {},
        newCustomGeoVersion: null,
        geoObjects: {},
        initGeoObjects: {},
        filterGeoObjectsVersionActive: false,
        filterCustomGeoObjectsVersionActive: false,
        filterGeoObjectsVersionDisabled: false,
        filterCustomGeoObjectsVersionDisabled: false,
        inspectorInfo: { type: 'default', data: null, title: 'well' },
        curvesArray: [],
        perforation: [],
        filteredCurveData: [],
        geoVersionsFilterKeys: filterItems,
        isCustomVersionsLoading: false,
        isCustomVersionChanged: false,
        isCustomGeoObjectsTableClosed: true,
    },
    reducers: {
        // Remove
        'tablets/onTabletSelected': (state, payload) => {
            return { ...state, title: payload };
        },
        'inspectorToggle': state => {
            return { ...state, visible: !state.visible };
        },

        'setGeoObjects': (state, payload) => {
            const { geoObjects } = state;

            return {
                ...state,
                geoObjects: { ...geoObjects, ...payload },
            };
        },
        'setCustomGeoObjects': (state, payload) => {
            return {
                ...state,
                customGeoObjects: payload,
            };
        },
        'setIsCustomVersionsLoading': (state, payload) => {
            return { ...state, isCustomVersionsLoading: payload };
        },
        'setIsCustomVersionChanged': (state, payload) => {
            return { ...state, isCustomVersionChanged: payload };
        },
        'setIsCustomGeoObjectsTableClosed': (state, payload) => {
            return { ...state, isCustomGeoObjectsTableClosed: payload };
        },

        'toggleFilterGeoObjects': state => {
            return { ...state, filterGeoObjectsVersionActive: !state.filterGeoObjectsVersionActive };
        },

        'toggleFilterCustomGeoObjects': state => {
            return { ...state, filterCustomGeoObjectsVersionActive: !state.filterCustomGeoObjectsVersionActive };
        },

        'toggleDisabledFilterGeoObjects': (state, payload) => {
            return { ...state, filterGeoObjectsVersionDisabled: payload };
        },

        'toggleDisabledFilterCustomGeoObjects': (state, payload) => {
            return { ...state, filterCustomGeoObjectsVersionDisabled: payload };
        },

        'offGeoObjectsFilter': state => {
            return { ...state, filterGeoObjectsVersionActive: false };
        },
        'offCustomGeoObjectsFilter': state => {
            return { ...state, filterCustomGeoObjectsVersionActive: false };
        },
        'setWellTitle': (state, payload) => {
            return { ...state, wellTitle: payload };
        },
        'tabletObjectsModel/setCurves': state => {
            return state;
        },

        'setInspectorInfo': (state, payload) => {
            return { ...state, inspectorInfo: payload };
        },
        'setCurvesArray': (state, payload) => {
            return { ...state, curvesArray: payload };
        },
        'setObjects': (state, payload) => {
            return { ...state, objects: payload };
        },
        'resetData': state => {
            return {
                ...state,
                inspectorInfo: { type: 'well', data: state.filteredCurveData, title: state.wellTitle },
                title: state.wellTitle,
            };
        },
        'setLithologyMetaData': (state, payload) => {
            return { ...state, lithologyMetaData: payload };
        },
        'setPerforation': (state, payload) => {
            return { ...state, perforation: payload };
        },
        'setFilteredCurveData': (state, payload) => {
            return { ...state, filteredCurveData: payload };
        },
        'setInitGeoVersions': (state, payload) => {
            const { initGeoObjects } = state;
            return { ...state, initGeoObjects: { ...initGeoObjects, ...payload } };
        },
        'setAllMinesAndWells': (state, payload) => {
            const { allInfo, fieldId } = payload;
            return { ...state, allMinesAndWells: { ...state.allMinesAndWells, [fieldId]: allInfo } };
        },
        'setAllWellVersions': (state, payload) => {
            const { wellId, allVersions } = payload;
            return { ...state, allWellVersions: { ...state.allWellVersions, [wellId]: allVersions } };
        },
        'setNewCustomGeoVersion': (state, payload) => {
            return { ...state, newCustomGeoVersion: payload };
        },
        'setGeoVersionsFilterKeys': (state, payload) => {
            return { ...state, geoVersionsFilterKeys: payload };
        },
        'setAllCustomGeoVersions': (state, payload) => {
            return { ...state, allCustomGeoVersions: payload };
        },
    },
    effects: dispatch => ({
        async saveCustomGeoObject(payload, rootState) {
            const { tablets, inspector, lists } = rootState;
            const { wellsIds, body } = payload;
            const { customGeoObjects, geoObjects } = inspector;

            const { activeTabletId, activeGroupName, isAddCustomGeoVersionActive, list } = tablets;
            this.setIsCustomVersionsLoading(true);
            try {
                const response = await api.carottage.saveCustomGeoVersion(body);

                if (response[0]) {
                    this.setNewCustomGeoVersion(null);
                    dispatch.tablets.setNewCustomGeoObjects([]);
                    const filteredGeoVersions = geoObjects[activeGroupName || activeTabletId].filter(
                        ver => !ver.isNewCustom,
                    );

                    this.setGeoObjects({ [activeGroupName || activeTabletId]: filteredGeoVersions });
                    dispatch.tablets.toggleIsAddCustomGeoversionActive({ isAddCustomGeoVersionActive });

                    const addedWellIds = wellsIds;
                    response[0]?.wells_id.forEach(id => {
                        if (!wellsIds.includes(id)) addedWellIds.push(id);
                    });
                    dispatch.tablets.setCustomGeoObjects([]);
                    dispatch.tablets.setInitCustomGeoObjects([]);
                    dispatch.tablets.getGeoObjects({
                        ids: addedWellIds,
                        groupName: activeGroupName,
                        activeTabletId,
                        customGeoObjectsAction: true,
                    });
                }

                return response;
            } catch (e) {
                const error = new Error(e.message);
                error.info = `Сводный РИГИС не сохранен`;
                throw error;
            }
        },
        async getCustomGeoObjects(payload, rootState) {
            const { wellsId } = payload;
            try {
                const response = await api.carottage.getCustomGeoVersions(wellsId);
                return response;
            } catch (e) {
                const error = new Error(e.message);
                error.info = `Нет сводных РИГИС`;
                throw error;
            }
        },
        async getAllCustomRigisVersons(payload, rootState) {
            const { fieldId } = payload;

            try {
                const response = await api.carottage.getAllCustomGeoVersions(fieldId);

                this.setAllCustomGeoVersions(response);
                return response;
            } catch (e) {
                const error = new Error(e.message);
                error.info = `Нет сводных РИГИС`;
                throw error;
            }
        },

        async deleteCustomGeoObjects(payload, rootState) {
            const { tablets, inspector } = rootState;
            const {
                activeTabletId,
                activeGroupName,
                isAddCustomGeoVersionActive,
                isEditCustomGeoVersionActive,
                customGeoObjects,
                list,
            } = tablets;
            const { geoObjects, customGeoObjects: customGeoVersions } = inspector;
            const { id, wellsIds } = payload;
            this.setIsCustomVersionsLoading(true);
            try {
                const response = await api.carottage.deleteCustomGeoVersion(id);

                if (response) {
                    for (const [key, version] of Object.entries(geoObjects)) {
                        if (geoObjects[key]) {
                            const filteredGeoVersions = version.filter(ver => ver.stratumVersionId !== id);
                            const updatedVersions = filteredGeoVersions.map((obj, i) => ({
                                ...obj,
                                visible: i === 0,
                                number: i + 1,
                            }));

                            this.setGeoObjects({ [key]: [...updatedVersions] });
                        }
                    }
                    const filteredCustomGeoObjects = customGeoObjects.filter(obj => obj.versionId !== id);
                    dispatch.tablets.toggleIsEditCustomGeoversionActive({ isEditCustomGeoVersionActive });
                    dispatch.tablets.setCustomGeoObjects([]);
                    dispatch.tablets.setInitCustomGeoObjects([]);

                    Object.keys(list).forEach(key => {
                        wellsIds.forEach(wellId => {
                            if (list[key][wellId]) {
                                if (list[key][wellId]?.geoObjects?.versions) {
                                    list[key][wellId].geoObjects.versions = list[key][
                                        wellId
                                    ].geoObjects.versions.filter(ver => ver.versionId !== id);
                                }
                                if (list[wellId]?.geoObjects?.versions) {
                                    list[wellId].geoObjects.versions = list[wellId].geoObjects.versions.filter(
                                        ver => ver.versionId !== id,
                                    );
                                }
                            }
                        });
                    });
                    dispatch.tablets.getGeoObjects({
                        ids: wellsIds,
                        groupName: activeGroupName,
                        activeTabletId,
                        customGeoObjectsAction: true,
                    });
                }
            } catch (e) {
                const error = new Error(e.message);
                error.info = `Нет сводных РИГИС`;
                throw error;
            }
        },
        async updateCustomGeoObjects(payload, rootState) {
            const { versionId, body, wellsIds, updateExisted, deleteWellCustomVersion } = payload;
            const { trueBoredStratumsID } = body;
            const { inspector, tablets, lists } = rootState;
            const { activeTabletId, activeGroupName, customGeoObjects, isEditCustomGeoVersionActive } = tablets;
            const { geoObjects } = inspector;
            const activeItemKey = activeTabletId || activeGroupName;

            if (trueBoredStratumsID.length > 0) {
                try {
                    this.setIsCustomVersionsLoading(true);
                    const response = await api.carottage.updateCustomGeoVersion(versionId, body);

                    if (response) {
                        if (!updateExisted) {
                            dispatch.tablets.toggleIsEditCustomGeoversionActive({ isEditCustomGeoVersionActive });
                        }

                        wellsIds.forEach(id => {
                            if (!response[0].wells_id.includes(id) && geoObjects[id]) {
                                const filteredVersions = geoObjects[id]
                                    ?.filter(ver => ver.stratumVersionId !== response[0].stratumVersionId)
                                    .map((ver, i) => {
                                        ver.number = i + 1;
                                        return ver;
                                    });
                                this.setGeoObjects({ [id]: [...filteredVersions] });
                            } else {
                                Object.keys(geoObjects).forEach(key => {
                                    if (
                                        key !== id &&
                                        geoObjects[key].find(
                                            ver => ver.stratumVersionId === response[0].stratumVersionId,
                                        )
                                    ) {
                                        const filteredGeoVersions = geoObjects[key].filter(
                                            ver => ver.stratumVersionId !== response[0].stratumVersionId,
                                        );

                                        this.setGeoObjects({ [key]: [...filteredGeoVersions] });
                                    }
                                });
                            }
                        });

                        dispatch.tablets.setCustomGeoObjects([]);
                        dispatch.tablets.setInitCustomGeoObjects([]);
                        this.setGeoObjects(null);

                        dispatch.tablets.getGeoObjects({
                            ids: wellsIds,
                            groupName: activeGroupName,
                            activeTabletId,
                            updatedCustomVersion: true,
                            customGeoObjectsAction: true,
                        });
                    }

                    return response;
                } catch (e) {
                    const error = new Error(e.message);
                    error.info = `Нет сводных РИГИС`;
                    throw error;
                }
            }
        },
        async getAllMinesAndWells(payload, rootState) {
            const { fieldId } = payload;
            try {
                const response = await api.carottage.getAllMinesAndWells(fieldId);
                this.setAllMinesAndWells({ allInfo: response, fieldId });
                return response;
            } catch (e) {
                const error = new Error(e.message);
                error.info = `Нет сводных РИГИС`;
                throw error;
            }
        },
        async getAllWellVersions(payload, rootState) {
            const { wellId } = payload;
            try {
                const response = await api.carottage.getAllWellVersions(wellId);
                this.setAllWellVersions({ wellId, allVersions: response });
                return response;
            } catch (e) {
                const error = new Error(e.message);
                error.info = `Нет сводных РИГИС`;
                throw error;
            }
        },

        addCustomGeoVersion(payload, rootState) {
            const { inspector, tablets, lists } = rootState;
            const { customGeoObject, wellsIds, customGeoObjectsAction } = payload;
            const { activeItemKey } = lists;
            const { geoObjects, customGeoObjects } = inspector;
            const { activeGroupName, activeTabletId } = tablets;
            this.setIsCustomVersionsLoading(true);
            const key = activeTabletId || activeGroupName;

            wellsIds.forEach(id => {
                Object.keys(geoObjects).forEach(geoObjectKey => {
                    const currentKey =
                        !Number.isNaN(geoObjectKey) && Number(geoObjectKey) === id
                            ? id
                            : /[a-z]/i.test(geoObjectKey)
                              ? geoObjectKey
                              : '';

                    if (geoObjects[currentKey] && Array.isArray(geoObjects[currentKey])) {
                        const existingVersions = geoObjects[currentKey];

                        const existingIndex = existingVersions.findIndex(
                            obj => obj.stratumVersionId === customGeoObject.stratumVersionId,
                        );

                        if (existingIndex !== -1 && !customGeoObjectsAction) {
                            return;
                        }

                        if (customGeoObjectsAction) {
                            let updatedVersions;

                            if (existingIndex !== -1) {
                                updatedVersions = [...existingVersions];
                                const existingVersion = existingVersions[existingIndex];

                                const mergedVersion = {
                                    ...customGeoObject,
                                    wells_id: [
                                        ...new Set([
                                            ...(existingVersion.wells_id || []),
                                            ...(customGeoObject.wells_id || []),
                                        ]),
                                    ],
                                };

                                updatedVersions[existingIndex] = mergedVersion;
                            } else {
                                const existingCustomVersions = existingVersions.filter(v => v.isCustom);
                                const nonCustomVersions = existingVersions.filter(v => !v.isCustom);

                                if (customGeoObject.isCustom) {
                                    updatedVersions = [
                                        ...existingCustomVersions,
                                        customGeoObject,
                                        ...nonCustomVersions,
                                    ];
                                } else {
                                    updatedVersions = [
                                        ...existingCustomVersions,
                                        ...nonCustomVersions,
                                        customGeoObject,
                                    ];
                                }
                            }

                            const finalVersions = updatedVersions
                                .reduce((acc, version) => {
                                    const existing = acc.find(v => v.stratumVersionId === version.stratumVersionId);
                                    if (!existing) {
                                        acc.push({
                                            ...version,
                                            wells_id: [...new Set(version.wells_id || [])],
                                        });
                                    }
                                    return acc;
                                }, [])
                                .map((obj, i) => ({
                                    ...obj,
                                    visible: i === 0,
                                    isCustom: obj.isCustom || false,
                                    number: i + 1,
                                }));

                            this.setGeoObjects({ [currentKey]: finalVersions });
                        }
                    }
                });
            });

            if (customGeoObject.isNewCustom) {
                const existingCustomGeoObjects = customGeoObjects || {};
                if (
                    !existingCustomGeoObjects[key] ||
                    existingCustomGeoObjects[key].stratumVersionId !== customGeoObject.stratumVersionId
                ) {
                    this.setCustomGeoObjects({
                        ...existingCustomGeoObjects,
                        [key]: { ...customGeoObject },
                    });
                }
            }
        },
        addNewCustomGeoVersion(payload, rootState) {
            this.setNewCustomGeoVersion(payload);
        },

        removeNewCustomGeoVersion(payload, rootState) {
            const { inspector } = rootState;
            const { activeItemKey } = payload;
            const { geoObjects, customGeoObjects } = inspector;
            const activeGeoObjects = geoObjects[activeItemKey] || [];
            const updatedGeoObjects = activeGeoObjects.filter(obj => !obj.isNewCustom);

            const updatedCustomGeoObjects = { ...customGeoObjects };
            delete updatedCustomGeoObjects[activeItemKey];

            const isDifferent = JSON.stringify(updatedCustomGeoObjects) !== JSON.stringify(customGeoObjects);

            if (isDifferent) {
                this.setCustomGeoObjects(updatedCustomGeoObjects);
            }
            this.setNewCustomGeoVersion(null);

            this.setGeoObjects({ [activeItemKey]: updatedGeoObjects });
        },
        updateCustomGeoObject(payload, rootState) {
            const { key, value, versionId, isNew } = payload;
            const { inspector, tablets } = rootState;

            const { geoObjects, newCustomGeoVersion } = inspector;
            const { activeTabletId, activeGroupName } = tablets;

            const activeKey = activeTabletId || activeGroupName;
            const activeGeoObjects = geoObjects[activeKey];
            if (!activeGeoObjects) return;
            if (isNew) {
                const updatedNewCustomGeoVersion = { ...newCustomGeoVersion };
                if (key === 'access') {
                    updatedNewCustomGeoVersion.isPrivate = value === 1;
                    updatedNewCustomGeoVersion.readOnly = value === 2;
                } else {
                    updatedNewCustomGeoVersion[key] = value;
                }

                this.setNewCustomGeoVersion(updatedNewCustomGeoVersion);
            } else {
                const { customObject, otherObjects } = activeGeoObjects.reduce(
                    (acc, obj) => {
                        if (obj.stratumVersionId === versionId) {
                            if (key === 'access') {
                                obj.isPrivate = value === 1;
                                obj.readOnly = value === 2;
                            }
                            acc.customObject = { ...obj, [key]: value };
                        } else {
                            acc.otherObjects.push(obj);
                        }
                        return acc;
                    },
                    { newCustomObject: null, otherObjects: [] },
                );

                if (!customObject) return;

                this.setGeoObjects({
                    [activeKey]: [customObject, ...otherObjects],
                });
            }
        },

        getGeoObjectsList(payload, rootState) {
            const { tablets, lists } = rootState;
            const { activeTabletId, activeGroupName } = tablets;
            const { activeItemKey, activeGroupKey } = lists;

            if (activeTabletId) {
                this.setGeoObjects({ [activeTabletId]: [] });
                this.setInitGeoVersions({ [activeTabletId]: [] });
            } else {
                this.setGeoObjects({ [activeGroupName]: [] });
                this.setInitGeoVersions({ [activeGroupName]: [] });
            }

            this.toggleDisabledFilterGeoObjects(true);

            const getCurrentGroupWellIds = data =>
                data.reduce((acc, item) => {
                    if (item.key === activeItemKey || (item.node === 'group' && item.key === activeGroupKey)) {
                        if (item.children?.length) {
                            return [...acc, ...item.children.map(i => i.id)];
                        } else {
                            return [...acc, item.id];
                        }
                    } else {
                        return [...acc];
                    }
                }, []);

            const wellIds = getCurrentGroupWellIds(lists.data);

            const relevantVersions = payload.filter(version => {
                if (activeTabletId) {
                    return version.wells_id && version.wells_id.includes(activeTabletId);
                }

                if (activeGroupName && wellIds.length > 0) {
                    return version.wells_id && version.wells_id.some(wellId => wellIds.includes(wellId));
                }

                return true;
            });

            const deduplicatedPayload = relevantVersions.reduce((acc, version) => {
                const existingIndex = acc.findIndex(v => v.stratumVersionId === version.stratumVersionId);

                if (existingIndex !== -1) {
                    const existing = acc[existingIndex];
                    const mergedVersion = {
                        ...existing,
                        wells_id: [...new Set([...(existing.wells_id || []), ...(version.wells_id || [])])],
                        isCustom: existing.isCustom || version.isCustom,
                        priority: Math.max(existing.priority || 0, version.priority || 0),
                    };

                    acc[existingIndex] = mergedVersion;
                } else {
                    acc.push({
                        ...version,
                        wells_id: [...new Set(version.wells_id || [])],
                    });
                }

                return acc;
            }, []);

            const dataWithVisible = deduplicatedPayload.map((version, i) => ({
                ...version,
                visible: i === 0,
                number: i + 1,
            }));

            const usedWellIds = new Set();
            const newVersions = dataWithVisible.map((v, i) => {
                const versionCopy = { ...v };

                if (wellIds.length > 0) {
                    const hasRequiredWell = versionCopy.wells_id.some(
                        version_id => wellIds.includes(version_id) && !usedWellIds.has(version_id),
                    );

                    if (hasRequiredWell && i === 0) {
                        // ARM-5055 показываем только первую версию из доступных
                        versionCopy.visible = true;

                        versionCopy.wells_id.forEach(wellId => {
                            if (wellIds.includes(wellId)) {
                                usedWellIds.add(wellId);
                            }
                        });
                    } else {
                        versionCopy.visible = false;
                    }
                }

                return versionCopy;
            });

            if (activeTabletId) {
                this.setGeoObjects({ [activeTabletId]: newVersions });
                this.setInitGeoVersions({ [activeTabletId]: JSON.parse(JSON.stringify(newVersions)) });
            } else {
                this.setGeoObjects({ [activeGroupName]: newVersions });
                this.setInitGeoVersions({ [activeGroupName]: JSON.parse(JSON.stringify(newVersions)) });
            }

            this.toggleDisabledFilterGeoObjects(false);
            return newVersions;
        },
        getCustomGeoObjectsList(payload, rootState) {
            const { tablets, lists } = rootState;
            const { activeTabletId, activeGroupName } = tablets;
            const { activeItemKey } = lists;

            if (activeTabletId) {
                this.setCustomGeoObjects({ [activeTabletId]: [] });
            } else {
                this.setCustomGeoObjects({ [activeGroupName]: [] });
            }

            this.toggleDisabledFilterCustomGeoObjects(true);

            const dataWithVisible = payload.map((version, i) => {
                version.visible = false;
                version.number = i + 1;
                return version;
            });

            const getCurrentGroupWellIds = data =>
                data.reduce((acc, item) => {
                    if (item.key === activeItemKey) {
                        if (item.children?.length) {
                            return [...acc, ...item.children.map(i => i.id)];
                        } else {
                            return [...acc, item.id];
                        }
                    } else {
                        return [...acc];
                    }
                }, []);

            const wellIds = getCurrentGroupWellIds(lists.data);

            const newVersions = dataWithVisible.map(v => {
                if (wellIds.length) {
                    v.wells_id.forEach(version_id => {
                        if (wellIds.length) {
                            const index = wellIds.findIndex(well_id => well_id === version_id);
                            if (index !== -1) {
                                v.visible = true;

                                wellIds.splice(index, 1);
                            }
                        }
                    });
                }
                return v;
            });

            if (activeTabletId) {
                this.setCustomGeoObjects({ [activeTabletId]: newVersions });
            } else {
                this.setCustomGeoObjects({ [activeGroupName]: newVersions });
            }
            this.toggleDisabledFilterCustomGeoObjects(false);
            return newVersions;
        },

        resetGroupGeoObjectsList(payload, rootState) {
            const { tablets } = rootState;
            const { activeGroupName } = tablets;

            this.setGeoObjects({ [activeGroupName]: [] });
        },
        resetGroupCustomGeoObjectsList(payload, rootState) {
            const { tablets } = rootState;
            const { activeGroupName } = tablets;

            this.setCustomGeoObjects({ [activeGroupName]: [] });
        },

        filterGeoObjectsClick(payload, rootState) {
            const { inspector, tablets, lists } = rootState;
            const { activeItemKey } = lists;
            const { filterGeoObjectsVersionDisabled, geoObjects, filterGeoObjectsVersionActive } = inspector;
            const { tabletInGroupSelected, activeGroupName, isGroup, list } = tablets;

            if (!filterGeoObjectsVersionDisabled && tabletInGroupSelected && isGroup) {
                this.toggleFilterGeoObjects();

                const versions = geoObjects[activeGroupName];
                const wellsValues = Object.values(list[activeGroupName]);
                const selectedWellFromList = wellsValues.find(well => well.key === activeItemKey);
                const versionsId = Object.keys(selectedWellFromList.lithology.versions).map(item => +item);

                const filteredVersions = versions
                    .map(version => {
                        if (versionsId.includes(version.stratumVersionId)) {
                            return version;
                        }
                        return null;
                    })
                    .filter(item => {
                        if (item !== null) return item;
                    });

                this.setGeoObjects({ [activeItemKey]: filteredVersions });
            }

            if (filterGeoObjectsVersionActive) {
                this.resetGeoObjectsFilter();
            }
        },

        filterCustomGeoObjectsClick(payload, rootState) {
            const { inspector, tablets, lists } = rootState;
            const { activeItemKey } = lists;
            const { filterGeoObjectsVersionDisabled, geoObjects, filterGeoObjectsVersionActive } = inspector;
            const { tabletInGroupSelected, activeGroupName, isGroup, list } = tablets;

            if (!filterGeoObjectsVersionDisabled && tabletInGroupSelected && isGroup) {
                this.toggleFilterCustomGeoObjects();

                const versions = geoObjects[activeGroupName];
                const wellsValues = Object.values(list[activeGroupName]);
                const selectedWellFromList = wellsValues.find(well => well.key === activeItemKey);
                const versionsId = Object.keys(selectedWellFromList.lithology.versions).map(item => +item);

                const filteredVersions = versions
                    .map(version => {
                        if (versionsId.includes(version.stratumVersionId)) {
                            return version;
                        }
                        return null;
                    })
                    .filter(item => {
                        if (item !== null) return item;
                    });

                this.setCustomGeoObjects({ [activeItemKey]: filteredVersions });
            }

            if (filterGeoObjectsVersionActive) {
                this.resetCustomGeoObjectsFilter();
            }
        },

        resetGeoObjectsFilter() {
            this.offGeoObjectsFilter();
        },

        resetCustomGeoObjectsFilter() {
            this.offCustomGeoObjectsFilter();
        },
        setInspectorType(payload, rootState) {
            const { activeItemKey, data } = rootState.lists;
            const { list, activeGroupName } = rootState.tablets;
            const { filteredCurveData } = rootState.inspector;

            // легаси
            // const result = getCurvesData(activeItemKey, list, activeGroupName, 'well');
            const result = getActiveCurves(activeItemKey, list, activeGroupName, rootState);
            this.setCurvesArray(result);

            if (payload?.break) {
                return;
            }

            const type = getItemByKeyRecursive(data, activeItemKey)?.node;

            if (type === 'well') {
                const title = getItemByKeyRecursive(data, activeItemKey).title;
                this.setInspectorInfo({ type: 'well', data: filteredCurveData, title });
                this.setWellTitle(title);
            }

            if (type === 'group') {
                this.setInspectorInfo({
                    type: 'group',
                    data: { group: { title: 'Выберите скважину из списка слева' } },
                    title: 'Планшет не выбран.',
                });
            }
        },
        /*
            ! Из за перевода информации в tooltip, сейчас используется только условие types.CURVES.
        */
        setInspectorInfoEffect(payload, rootState) {
            const {
                tabletObjectsModel,
                runner: { depth },
            } = rootState;
            const payloadData = tabletObjectsModel[payload.activeState];
            const { curvesArray, objects, perforation } = rootState.inspector;

            let data;
            let title;

            const type = mapping(payloadData.type);

            let { id } = payloadData;
            let idx = 0;

            if (type === types.CURVES) {
                /*
                    ! Временно убрана эта фильтрация.
                    Для показа будет отключено пересечение кривой с бегунком, если он будет выключен.

                    const dt = filterCurvesByRunnerValue(depth.relative, curvesArray);
                */

                const dt = curvesArray;

                /*
                    Эта штука, как я понял, раньше работа так, что ожидала массив ids.
                    Так как выборка происходила множественная.

                    Было так:
                    data = payloadData.ids.map(i => dt.filter(it => it.code === i)).flat();
                */
                /*
                    Пока временно работаем так же с массивом, чтобы не нарушить эту логику.
                */

                const ids = payloadData ? (payloadData.ids ? payloadData.ids.flat() : [payloadData.id]) : [];

                data = ids.map(i => dt.filter(it => it.code === i)).flat();

                /*
                    Фильтруем ПОЛНЫЕ дубликаты
                 */
                data = data.filter(
                    (value, index, self) =>
                        index ===
                        self.findIndex(
                            t =>
                                t.defsStart === value.defsStart &&
                                t.defsStop === value.defsStop &&
                                t.depthMax === value.depthMax &&
                                t.depthMin === value.depthMin &&
                                t.x.length === value.x.length &&
                                t.y.length === value.y.length,
                        ),
                );

                if (data.length > 1) {
                    const ttl = data.map(item => item.title);
                    // const modifiedTitle = ttl.map(i => {
                    //     return i.split('|').reverse().slice(1).join('').trim();
                    // });
                    title = `${ttl.join(', ')} (${data.length})`;
                } else if (data.length === 1) {
                    title = data[0].title;
                }
            } else if (type === types.LAYER) {
                const [versionId, layerId] = parseId(id);

                data = objects.find(item => item.stratumVersionId === versionId && item.boredStratumId === layerId);
                title = data?.boredStratumTitle ?? 'Пласт';
            } else if (type === types.LITHOLOGY) {
                data = objects
                    .map(it => {
                        return it.children
                            .map((child, idx) => ({
                                ...child,
                                idx: idx + 1,
                                boredStratumTitle: it.boredStratumTitle,
                            }))
                            .filter(child => child.boredSeamId == id);
                    })
                    .flat()[0];

                title = data ? `${data.idx} из ${data.boredStratumTitle}` : 'Литология';
            } else if (type === types.PERFORATION) {
                if (id && id.toString().indexOf('-') !== -1) {
                    id = payloadData.id.split('-')[0];
                    idx = payloadData.id.split('-')[1];
                }

                /*
                    ! WARNING: ошибка возникает в этом месте, при клике на перфорацию
                */
                const selectedPerforation = rootState.inspector.perforation[id][idx];

                const preparedPerforationData = Object.entries(perforation);
                const dataWithActiveField = addActiveFieldToPerforation(preparedPerforationData, id, idx);
                data = filterPerforation(depth.relative, dataWithActiveField);

                // заменить получение данных на этот метод, если бегунок сломается
                // data = filterPerforationByRange(dataWithActiveField, selectedPerforation);

                filterPerforationByRange(dataWithActiveField, selectedPerforation);
                title = 'Перфорация/изоляция';
            } else {
                data = curvesArray;
            }

            this.setInspectorInfo({ type: type, data, title });
        },
        getObjects(payload, rootState) {
            // fixme?
            const key = rootState.lists.activeItemKey;
            const { activeGroupName, list, activeTabletId, activeGroupIds } = rootState.tablets;
            const { inspectorInfo, geoObjects, objects } = rootState.inspector;
            const type = inspectorInfo.type;
            let well;
            let wells;

            if (activeGroupName && (type === 'group' || type === 'well') && activeGroupIds.length > 0) {
                wells = list[activeGroupName];
            } else {
                well = list[activeTabletId];
            }

            if (!well && !wells) return;
            if (well) {
                if (!well.id) {
                    return;
                }
                const geoObjectsList = geoObjects[well.id];
                const versions = well?.geoObjects?.versions;
                const perforation = well?.wellServices?.perforation;

                if (geoObjectsList && versions) {
                    const objData = formatgeoObjectsForScrollList(geoObjectsList, versions);
                    this.setObjects(objData);
                } else {
                    this.setObjects(isEmpty(objects) ? objects : []);
                }

                if (!versions) return null;
                this.setPerforation(perforation);
            }
            if (wells) {
                if (!well || !well.id) {
                    return;
                }
                Object.values(wells).forEach(well => {
                    const geoObjectsList = geoObjects[well.id];
                    const versions = well?.geoObjects?.versions;
                    const perforation = well?.wellServices?.perforation;
                    if (geoObjectsList && versions) {
                        const objData = formatgeoObjectsForScrollList(geoObjectsList, versions);
                        this.setObjects(objData);
                    } else {
                        this.setObjects(isEmpty(objects) ? objects : []);
                    }

                    if (!versions) return null;
                    this.setPerforation(perforation);
                });
            }
            /*
                Это версии РИГИС из менеджера РИГИС (без доп данных)
            */
            // let wellRigis;
        },
        reset(_, rootState) {
            if (rootState?.inspector?.filteredCurveData && types?.DEFAULT)
                this.resetData({ type: types.DEFAULT, data: rootState.inspector.filteredCurveData });
            this.setInspectorType();
            dispatch.runner.setIsActiveRunner(true);
            dispatch.tabletObjectsModel.reset();
        },
        init(_, rootState) {
            if (rootState.tablets.list) {
                this.setInspectorType();
            }
            if (rootState.lists && rootState.tablets && rootState.inspector) this.getObjects();
            // this.getGeoObjectsList();
        },
        setFilterCurves(_, rootState) {
            const { curvesArray } = rootState.inspector;
            const { depth } = rootState.runner;
            this.setFilteredCurveData(filterCurvesByRunnerValue(depth.relative, curvesArray));
        },
    }),
};

// легаси
// получение всех кривых на пшаншете
function getCurvesData(key, carrotage, activeGroupName, type) {
    let wells;

    if (activeGroupName && type === 'well') {
        wells = Object.values(carrotage[activeGroupName]).filter(item => item.key === key);
    } else {
        wells = Object.values(carrotage).filter(item => item.key === key);
    }

    const curvesData = [];

    wells.forEach(item => {
        const curves = item.carottage.columns;
        if (!curves) return;

        curves.forEach(curve => {
            curve.forEach(item => {
                return curvesData.push({
                    title: item.title,
                    color: item.color,
                    date: item.date,
                    group: item.group,
                    code: item.code,
                    depthMin: item.DepthStart,
                    depthMax: item.DepthStop,
                    defsStart: item.xStart,
                    defsStop: item.xStop,
                    x: item.x,
                    y: item.y,
                });
            });
        });
    });

    return curvesData;
}

function getActiveCurves(activeItemKey, list, activeGroupName, rootState) {
    let wells;

    if (activeGroupName && list[activeGroupName]) {
        wells = Object.values(list[activeGroupName]).filter(item => item && item.key === activeItemKey);
    } else {
        wells = Object.values(list).filter(item => item && item.key === activeItemKey);
    }

    const curves = rootState.curves.data;
    const curveSettings = rootState.curveSettings.data;

    const curvesData = [];

    wells.forEach(well => {
        if (!well || !well.id || !well.key) return;

        const researches = rootState.researches.data[well.id];
        const tabletSettings = rootState.tabletSettings[well.key];
        const activeKeys = tabletSettings?.wellLoggingKeys ?? [];

        if (researches) {
            researches.forEach(r1 => {
                r1.children.forEach(r2 => {
                    r2.children.forEach(research => {
                        if (activeKeys.includes(research.key)) {
                            const curve = curves[research.curve];
                            const rawSettings = curveSettings[research.code];
                            const customSettings = tabletSettings?.curveSettings?.[research.key];
                            const withoutSettings = isEmpty(rawSettings) && isEmpty(customSettings);

                            if (!curve || withoutSettings) return;

                            const settings = {
                                ...rawSettings,
                                ...customSettings,
                            };

                            curvesData.push({
                                title: curve.name,
                                id: curve.id,
                                color: settings.color,
                                width: settings.lineWidth,
                                date: research.date,
                                group: settings.parentName,
                                code: settings.code,
                                depthMin: curve.depthStart,
                                depthMax: curve.depthStop,
                                defsStart: curve.xStart,
                                defsStop: curve.xStop,
                                x: curve.x,
                                y: curve.y,
                            });
                        }
                    });
                });
            });
        }
    });

    return curvesData;
}

// фильтр всех перфораций по точке пересечения с бегунком
function filterPerforation(runnerValue, data) {
    return data.flat(2).filter(it => runnerValue >= it.roof && runnerValue <= it.bottom);
}

// фильтр всех кривых на планшете по пересечению с бегунком
function filterCurvesByRunnerValue(runnerValue, data) {
    return data.filter(it => runnerValue >= it.depthMin && runnerValue <= it.depthMax);
}

// фильтр перфораций путем сравнения мин и макс точек
function filterPerforationByRange(data, selectedPerforation) {
    const filteredPerforation = [];
    return data.map(it => {
        if (
            (it.roof >= selectedPerforation.roof && it.bottom <= selectedPerforation.bottom) ||
            (it.roof >= selectedPerforation.roof && it.bottom >= selectedPerforation)
        )
            filteredPerforation.push(it);
        return filteredPerforation;
    });
}

// добавдяет поле isActive для выбранной перфорации
function addActiveFieldToPerforation(data, id, idx) {
    return data.reduce((prev, current) => {
        const [key, value] = current;

        return prev.concat(
            ...value.map((item, i) => {
                return {
                    ...item,
                    isActive: key === id.toString() && i.toString() === idx,
                };
            }),
        );
    }, []);
}

function formatgeoObjectsForScrollList(versionsList, version) {
    const objData = [];
    let count = 0;

    for (const item of versionsList) {
        const { stratumVersionId } = item;
        const geoObjects = version[stratumVersionId];

        if (geoObjects && geoObjects.visible) {
            const priorityGeoObjectsData = geoObjects.data.map(item => ({
                priority: count,
                stratumVersionId,
                ...item,
            }));
            objData.push(...priorityGeoObjectsData);
        }
        count += 1;
    }

    return objData;
}

export default inspectorModel;
